
import Button from '../storyblok/Button.vue'
import RichText from '../common/RichText.vue'

export default {
  name: 'DrinkDeliveryBanner',
  components: { Button, RichText },
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
}
